module.exports = __webpack_public_path__ + "img/林素琴.c25e55a2.jpg";